export const endpoints = {
  recipeDtails: "/recipe/${recipeUuid}/details",
};

export const buildApiUrl = (endpoint: string, params: any) => {
  let url = endpoint;
  Object.keys(params).forEach((key) => {
    url = url.replace(`\${${key}}`, params[key]);
  });

  return url;
};
